import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import warningAmber from "assets/images/icons/warning_amber.svg";
import { BackButtonPage } from "components/__new/common/BackButton";
import { Checkbox } from "components/__new/common/form";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useLoginInfo from "hooks/useLoginInfo";
import { WalletBalanceInfo } from "components/__new/wallet/WalletBalanceInfo";
import * as walletAction from "store/entities/wallet/action";


export const WalletFund = () => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { dashboardLoading, dashboard } = useSelector((s) => s.entities.wallet);


    const getDashboard = () => {
        if (dashboardLoading === false && dashboard?.status !== "success"){
            dispatch(walletAction.getDashboard(userInfo));
        }
    }


    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line
    }, []);

    return (
        <div>


            <DynamicHeadTag
                headerText="Fund | Wallet"
            />
        

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <BackButtonPage link="/payments/account" />
                        <div>
                            Fund Wallet
                            <div className="text-sm font-normal">
                                You can top up your wallet here
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-4 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 box">
                <div>
                    <Checkbox
                        type="radio"
                        label="Bank Transfer"
                        checked={true}
                        readonly={true}
                    />
                </div>


                <div className="p-6 mt-8 max-w-lg rounded-md border border-gray-200">
                    <div>
                        Use this number to transfer funds to your wallet
                    </div>
                    <div className="p-4 mt-4 rounded-md border border-dashed border-gray-400 space-y-4">

                        <WalletBalanceInfo
                            loading={dashboardLoading}
                            name="Account number"
                            value={dashboard?.data?.walletDetails?.accountNumber}
                        />
                        
                        <WalletBalanceInfo
                            loading={dashboardLoading}
                            name="Bank name"
                            value={<span className="capitalize">{dashboard?.data?.walletDetails?.bankName}</span>}
                        />

                        <WalletBalanceInfo
                            loading={dashboardLoading}
                            name="Account name"
                            value={dashboard?.data?.walletDetails?.accountName}
                        />

                    </div>
                </div>


                <div className="p-3 mt-8 max-w-lg text-red-500 bg-red-100 rounded-md flex space-x-2 text-xs">
                    <img src={warningAmber} alt="warning" className="w-4 h-4 mr-2 object-contain" />
                    Bank transfers from third party accounts will be applied to your account after 24hrs. For instant transactions. Please send funds from accounts owned by you
                </div>
            </div>


        </div>
    )
}


export default WalletFund;